<pg-not-found>
  <template if={state.showNotFound}>
    <h1>NOT FOUND</h1>

  </template>

  <script>
    import './pg-not-found.scss'

    import { route, toRegexp, match } from '@riotjs/route'

    import routes from '../routes'

    export default {
      state: {
        showNotFound: false
      },
      onBeforeMount () {
        // Listens change in all routes, to verify if match some one. If not does, show this page
        route('(.*)').on.value(this.doSomething)
      },
      doSomething(data) {
        this.update({
          showNotFound: this.verifyRoute(data.href)
        })
      },
      verifyRoute(path) {
        return !routes.some(p => match(path, toRegexp(p.path)))
      },
    }
  </script>
</pg-not-found>
